import React from "react";
import { useRental } from "../../../../contexts/api/rental";
import type { RentalProduct, RentalProductRequest } from "../../../../api/rental/Rental.typed";

export default function useRentalProducts() {
  const { listRentalProducts, createRentalProduct, updateRentalProduct, deleteRentalProduct } =
    useRental();
  const [products, setProducts] = React.useState<RentalProduct[]>([]);
  const [loading, setLoading] = React.useState(true);

  const reload = React.useCallback(async () => {
    setLoading(true);
    const data = await listRentalProducts();
    if (data) setProducts(data);
    setLoading(false);
  }, [listRentalProducts]);

  React.useEffect(() => {
    reload();
  }, [reload]);

  const create = React.useCallback(
    async (req: RentalProductRequest) => {
      const created = await createRentalProduct(req);
      if (created) setProducts((prev) => [...prev, created]);
      return created;
    },
    [createRentalProduct],
  );

  const update = React.useCallback(
    async (id: number, req: RentalProductRequest) => {
      const updated = await updateRentalProduct(id, req);
      if (updated) setProducts((prev) => prev.map((p) => (p.id === id ? updated : p)));
      return updated;
    },
    [updateRentalProduct],
  );

  const remove = React.useCallback(
    async (id: number) => {
      const ok = await deleteRentalProduct(id);
      if (ok) setProducts((prev) => prev.filter((p) => p.id !== id));
    },
    [deleteRentalProduct],
  );

  return { products, loading, reload, create, update, remove };
}
